module.exports = __webpack_public_path__ + "static/media/landscape_mouth_nose.ce588318.jpg";